import React from "react";
import { Input } from "@/components/ui/input";
import NoteSection from "@/components/shownotes/NoteSection";
import { TIME_ROWS, totalMinutes, fmtMinutes } from "@/components/shownotes/meta";

// Show Notes section 2: Act I / Intermission / Act 2 time + duration; Total Time duration is the sum.
export default function TimesSection({ fields, set }) {
  const times = fields.times;
  const setRow = (k, patch) => set({ times: { ...times, [k]: { ...times[k], ...patch } } });
  const total = totalMinutes(times);
  return (
    <NoteSection title="Times" testId="notes-section-times">
      <div className="grid grid-cols-[1fr_auto_auto] items-center gap-x-3 gap-y-2 text-sm">
        <span />
        <span className="text-xs font-semibold text-slate-600">Time</span>
        <span className="text-xs font-semibold text-slate-600">Duration (min)</span>
        {TIME_ROWS.map(([k, label]) => (
          <React.Fragment key={k}>
            <span className="font-medium text-slate-700">{label}</span>
            <Input type="time" className="w-36" value={times[k].time} onChange={(e) => setRow(k, { time: e.target.value })} data-testid={`notes-time-${k}`} />
            <Input type="number" min={0} max={600} className="w-28" value={times[k].duration}
              onChange={(e) => setRow(k, { duration: e.target.value })} data-testid={`notes-duration-${k}`} />
          </React.Fragment>
        ))}
        <span className="font-bold text-slate-900">Total Time</span>
        <Input type="time" className="w-36" value={times.total.time} onChange={(e) => setRow("total", { time: e.target.value })} data-testid="notes-time-total" />
        <p className="w-28 rounded-md bg-slate-900 px-3 py-2 text-center text-sm font-bold tabular-nums text-white" data-testid="notes-duration-total">{fmtMinutes(total)}</p>
      </div>
    </NoteSection>
  );
}
